"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartColors = void 0;
exports.chartColors = {
    primary: { base: "#0EA5E9", faded: "#7DD3FC" },
    secondary: { base: "#06B6D4", faded: "#67E8F9" },
    success: { base: "#10B981", faded: "#6EE7B7" },
    warning: { base: "#F59E0B", faded: "#FCD34D" },
    danger: { base: "#EF4444", faded: "#FCA5A5" },
    muted: { base: "#94A3B8", faded: "#CBD5E1" },
};
